import { round } from './round';

export function toPercent(value: number, precision = 0): string {
  const percentValue = round(value * 100, precision);

  return `${percentValue.toFixed(precision).replace('.', ',')}%`;
}
